import { render, staticRenderFns } from "./AdvList.vue?vue&type=template&id=9ef7775a&"
import script from "./AdvList.vue?vue&type=script&lang=js&"
export * from "./AdvList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports